import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import PageHeader from "../../components/shared/PageHeader";
import MainContent from "../../containers/shared/MainContent";
import PageMain from "../../containers/shared/PageMain";
import NormalFormContainer from "../../containers/shared/NormalFormContainer";
import apiClient from "../../components/utils/apiClient";
import { useEffect, useRef, useState } from "react";
import Loading from "../../components/shared/Loading";
import Toast from "../../components/shared/Toast";
import NormalButton from "../../components/shared/NormalButton";

const InvoiceStatus = () => {
    const { t, i18n } = useTranslation();

    useDocumentTitle(t('invoiceStatus.trackRequest'));
    const { id } = useParams();
    const pageTitle = {title: t('invoiceStatus.requestNo')+id, subTitle: ''};
    const [singleRequest, setSingleRequest] = useState(null);
    const [isActionLoading, setIsActionLoading] = useState(false);
    const [toast, setToast] = useState({show: false,type: null, message:'' });

    const navigate = useNavigate();

    const getSingleRequest = async () => {
        try {
          const response = await apiClient.get(`/requests/prettyId?requestPrettyId=${id}`);
          if(response?.data) {
            // if(response?.data?.paymentStatuses && Array.isArray(response?.data?.paymentStatuses) && response?.data?.paymentStatuses?.length > 0 && ['requested','proceed','done','paid'].includes(response?.data?.paymentStatuses[response?.data?.paymentStatuses?.length-1]?.status)) {
            //     navigate(`/ar/invoice-status/${id}`);
            // }
            setSingleRequest(response?.data);
            // setCompleteRequestData({
            //     "requestId": response?.data?._id,
            //     "workersWage": response?.data?.maintenanceListHistory.reduce((a, c) => a + c.cost, 0),
            //     "partsCost": response?.data?.partsCost,
            //     "donation": 0,
            //     "workDoneList": response?.data?.maintenanceListHistory.map(item=>({ itemCode: item?.maintenance?.code, quantity: item?.amount, text: item?.maintenance?.name, cost: item?.cost }))
            // })
          } else {

          }
        } catch(err) {}
    }

    useEffect(()=>{
        if(id) {
            getSingleRequest();
        }
    },[id])

    const handleClickCloseRequest = async () => {
        setIsActionLoading(true);
        try {
          const response = await apiClient.patch(`/requests/done`,{"requestId": singleRequest?._id});
          if(response?.status === 200 || response?.status === 201 || response?.status === 204) {
            setToast({show:true,type:'success',message: t('invoiceStatus.requestSuccess')});
            navigate(`/${i18n?.language || 'ar'}/requests/${singleRequest?.requestPrettyId}`);
          } else {
            setToast({show:true,type:'error',message: t('invoiceStatus.errorTryAgain')});
            setIsActionLoading(false);
          }
        } catch(err) {
            setToast({show:true,type:'error',message: err?.response?.data?.message || t('invoiceStatus.errorTryAgain')});
            setIsActionLoading(false);
        }
    }


    return (
        <>
        <PageHeader pageTitle={pageTitle} isColored />
        <PageMain>
            <div className="absolute top-0 left-0 w-full h-full bg-grey-50 z-0"></div>
            {(singleRequest && !isActionLoading) &&<MainContent>
                <div className="w-full max-w-[917px] my-[32px] mx-auto p-[24px] bg-white border-[1px] border-grey-200 rounded-[12px]">

                    <div className="w-full text-center">
                        {singleRequest?.paymentStatuses[singleRequest?.paymentStatuses?.length-1]?.status === 'requested'
                        && <img src="/assets/images/loading-status.svg" alt="" className="animate-spin w-[88px] h-[88px] inline-block mb-[24px]" />}
                        {singleRequest?.paymentStatuses[singleRequest?.paymentStatuses?.length-1]?.status === 'proceed'
                        && <img src="/assets/images/success.svg" alt="" className="w-[88px] h-[88px] inline-block mb-[24px]" />}
                        {singleRequest?.paymentStatuses[singleRequest?.paymentStatuses?.length-1]?.status === 'rejected'
                        && <img src="/assets/images/err.svg" alt="" className="w-[88px] h-[88px] inline-block mb-[24px]" />
                        }
                        

                        <p className={`${singleRequest?.paymentStatuses[singleRequest?.paymentStatuses?.length-1]?.status === 'rejected' ? 'text-danger' : 'text-blue'} font-bold text-[24px] mb-[16px]`}>
                            {singleRequest?.paymentStatuses[singleRequest?.paymentStatuses?.length-1]?.status === 'requested' && t('invoiceStatus.godGiveHealth')}
                            {singleRequest?.paymentStatuses[singleRequest?.paymentStatuses?.length-1]?.status === 'proceed' && t('invoiceStatus.fulfilledIt')}
                            {singleRequest?.paymentStatuses[singleRequest?.paymentStatuses?.length-1]?.status === 'rejected' && t('invoiceStatus.alert')}
                        </p>
                        <p className={`${singleRequest?.paymentStatuses[singleRequest?.paymentStatuses?.length-1]?.status === 'rejected' ? 'text-danger' : ''} text-[18px] text-grey-900 mb-[16px]`}>
                            {singleRequest?.paymentStatuses[singleRequest?.paymentStatuses?.length-1]?.status === 'requested' && t('invoiceStatus.waitForCustomer')}
                            {singleRequest?.paymentStatuses[singleRequest?.paymentStatuses?.length-1]?.status === 'proceed' && t('invoiceStatus.confirmedByCustomer')}
                            {singleRequest?.paymentStatuses[singleRequest?.paymentStatuses?.length-1]?.status === 'rejected' && t('invoiceStatus.rejectedByCustomer')}
                        </p>

                        {singleRequest?.paymentStatuses[singleRequest?.paymentStatuses?.length-1]?.status === 'proceed' && <p className="text-[18px] text-grey-900 font-bold">
                            {singleRequest?.paymentMethod === 'cash'
                            ? t('invoiceStatus.payInCash')
                            : t('invoiceStatus.paidOnline')}
                        </p>}
                    </div>

                    <div className="pt-[24px]">
                        <div className="text-[16px] font-[500] text-grey-900 pb-[12px]">{t('invoiceStatus.invoiceDetails')}</div>
                        <div className="p-[16px] rounded-[16px] border-[1px] border-grey-300">
                            {/* <div className="flex flex-nowrap pb-[16px] border-b-[1px] border-dotted border-grey-300">
                                <div className="w-[50%] leading-[24px] h-[24px] text-grey-600 text-[16px] font-[500]">{t('invoiceStatus.totalServicesCost')}</div>
                                <div className="w-[50%] text-end leading-[24px] h-[24px] font-[500] text-[14px]">{singleRequest?.workerWageWithItsVat || 0} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div>
                            </div>
                            <div className="flex flex-nowrap pb-[16px] pt-[16px] border-b-[1px] border-dotted border-grey-300">
                                <div className="w-[50%] leading-[24px] h-[24px] text-grey-600 text-[16px] font-[500]">{t('invoiceStatus.spareParts')}</div>
                                <div className="w-[50%] text-end leading-[24px] h-[24px] font-[500] text-[14px]">{singleRequest?.partsCost || 0} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div>
                            </div>
                            <div className="flex flex-nowrap pt-[16px]">
                                <div className="w-[50%] leading-[24px] h-[24px] text-grey-600 text-[16px] font-[500]">{t('invoiceStatus.totalAmount')}</div>
                                <div className="w-[50%] text-end leading-[24px] h-[24px] font-[500] text-[14px]">{Number(singleRequest?.partsCost || 0) + Number(singleRequest?.workerWageWithItsVat) || 0} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div>
                            </div> */}


                            <div className="flex flex-nowrap bg-white px-[16px] border-b-[1px] border-dotted border-grey-300">
                                <div className="w-[50%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500]">{t('requests.totalWorkerWage')}</div>
                                <div className="w-[50%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">{singleRequest?.business ? singleRequest?.invoiceDetails?.workerWage : singleRequest?.workersWage} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div>
                            </div>

                            <div className="flex flex-nowrap bg-white px-[16px] border-b-[1px] border-dotted border-grey-300">
                                <div className="w-[50%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500]">{t('requests.totalPartsRequired')}</div>
                                <div className="w-[50%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">{singleRequest?.business ? singleRequest?.invoiceDetails?.partsCost : singleRequest?.partsCost} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div>
                            </div>

                            {singleRequest?.deliveryCostOfParts ? <div className="flex flex-nowrap bg-white px-[16px] border-b-[1px] border-dotted border-grey-300">
                                <div className="w-[50%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500]">{t('requests.partsDeliveryFees')}</div>
                                <div className="w-[50%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">{singleRequest?.business ? singleRequest?.invoiceDetails?.deliveryCostOfParts :singleRequest?.deliveryCostOfParts} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div>
                            </div> : ''}

                            {singleRequest?.serviceFee ? <div className="flex flex-nowrap bg-white px-[16px] border-b-[1px] border-dotted border-grey-300">
                                <div className="w-[50%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500]">{t('requests.serviceFees')}</div>
                                <div className="w-[50%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">{singleRequest?.business ? singleRequest?.invoiceDetails?.serviceFee :singleRequest?.serviceFee} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div>
                            </div> : ''}

                            {/* <div className="flex flex-nowrap bg-white px-[16px]">
                                <div className="w-[50%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500]">{t('requests.tax')}</div>
                                <div className="w-[50%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">{singleRequest?.business ? Math.abs(singleRequest?.invoiceDetails?.vatValue) : Math.abs(singleRequest?.vatValue)} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div>
                            </div> */}

                            {!singleRequest?.business ? <div className="flex flex-nowrap bg-white px-[16px] border-b-[1px] border-dotted border-grey-300">
                                <div className="w-[50%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500]">{t('requests.customerDiscount')}</div>
                                <div className="w-[50%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">{singleRequest?.business ? singleRequest?.invoiceDetails?.workerWage : Math.abs(singleRequest?.discount)} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div>
                            </div> : ''}

                            {!singleRequest?.business ? <div className="flex flex-nowrap bg-white px-[16px] border-b-[1px] border-dotted border-grey-300">
                                <div className="w-[50%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500]">{t('requests.workerTip')}</div>
                                <div className="w-[50%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">{singleRequest?.business ? singleRequest?.invoiceDetails?.workerWage : Math.abs(singleRequest?.tipAmount)} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div>
                            </div> : ''}

                            <div className="flex flex-nowrap bg-white px-[16px]">
                                <div className="w-[50%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500]">{t('requests.total')}</div>
                                <div className="w-[50%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">{singleRequest?.business ? Math.abs(singleRequest?.invoiceDetails?.total) : Math.abs(singleRequest?.totalAfterDiscount)} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div>
                            </div>

                            
                        </div>
                        <div className="text-center pt-[24px]">
                            {singleRequest?.paymentStatuses[singleRequest?.paymentStatuses?.length-1]?.status === 'proceed' && <NormalButton label={t('invoiceStatus.endRequest')}  isDisabled={''} onClick={handleClickCloseRequest} />}

                        </div>
                    </div>

                </div>
            </MainContent>}
        </PageMain>

        {(!singleRequest || isActionLoading) && <Loading showLoading={true} />}
        <Toast toast={toast} setToast={setToast} />    
        </>
    );

}

export default InvoiceStatus;